/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Media_PodcastInputs */



/**
* | output |
* | --- |
* | "Podcast" |
*
* @param {Community_Media_PodcastInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const community_media_podcast = /** @type {((inputs?: Community_Media_PodcastInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Media_PodcastInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Podcast")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pódcast")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Podcast")
	if (locale === "it") return /** @type {LocalizedString} */ ("Podcast")
	return /** @type {LocalizedString} */ ("Podcast")
});